import React from 'react';
import { Card, CardContent, Avatar, Typography, Box } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { User } from '../../Types/UnitFeatureTypes';

// Define types for the user card props
interface UserCardProps {
  user: {
    id: number;
    avatar?: string;
    first_name: string;
    last_name: string;
    email?: string;
    phone?: string;
  } | User;
  isOwner?: boolean;
}

const UserCard: React.FC<UserCardProps> = ({ user, isOwner }) => {
  const { avatar, first_name, last_name, email, phone } = user;
  return (
    <Card 
      elevation={5}
    onClick={() => console.log('User card clicked')}
      sx={{
        display: 'flex',
        padding: 2,
        borderRadius: 3,
        width: 300,
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'secondary.main',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#f9f9f8',
          transform: 'scale(1.01)',
          transition: 'transform 1s',
        },
      }}>
      <Avatar alt={
        `${first_name} ${last_name}`
      } src={avatar} sx={{width: 120, height: 120}}/>

      <CardContent sx={{height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{
          `${first_name} ${last_name}`
      } {isOwner ? "(Owner)" : "" }</Typography>
        
        {/* Email with Icon */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <EmailIcon sx={{ color: '#555' }} />
          <Typography variant="subtitle1" sx={{ color: '#555' }}>{email}</Typography>
        </Box>

        {/* Phone with Icon */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <PhoneIcon sx={{ color: '#555' }} />
          <Typography variant="subtitle1" sx={{ color: '#555' }}>
            {phone}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default UserCard;
